export default __webpack_public_path__ + "static/media/smile.ac21fba5.png";